<p-toast position="top-right"></p-toast>

<p-dialog [(visible)]="showAssignDriverDialog"
		  [modal]="true"
		  [style]="{ width: 'min(480px, calc(100vw - 2rem))' }"
		  [draggable]="false"
		  [closable]="true"
		  styleClass="assign-driver-dialog"
		  (onHide)="selectedDriverIdForAssign = null">
	<ng-template pTemplate="header">
		<span class="assign-driver-dialog__title">Assign driver</span>
	</ng-template>

	<div class="assign-driver-dialog__body">
		<label class="assign-driver-dialog__label" for="connex-driver-assign-dropdown">ConneX driver</label>
		<p-dropdown inputId="connex-driver-assign-dropdown"
					[options]="connexDriverOptions"
					[(ngModel)]="selectedDriverIdForAssign"
					optionLabel="label"
					optionValue="value"
					placeholder="Search or select a driver"
					[filter]="true"
					filterBy="label"
					[showClear]="true"
					[loading]="loadingConnexDrivers"
					styleClass="assign-driver-dialog__dropdown w-full"></p-dropdown>
		<p class="assign-driver-dialog__hint" *ngIf="vehicle">
			Vehicle ID {{ vehicle.Id }}<ng-container *ngIf="vehicle.NumberPlate"> · {{ vehicle.NumberPlate }}</ng-container>
		</p>
	</div>

	<ng-template pTemplate="footer">
		<div class="assign-driver-dialog__footer">
			<button pButton type="button" class="p-button-text" label="Cancel" (click)="showAssignDriverDialog = false"></button>
			<button pButton type="button" class="btn-darkblue" label="Assign" (click)="confirmAssignDriver()"></button>
		</div>
	</ng-template>
</p-dialog>

<p-sidebar [(visible)]="isVisible"
		   [position]="'right'"
		   [baseZIndex]="10000"
		   (onHide)="cancel()"
		   [style]="{width:'672px'}">
	<ng-template pTemplate="header">
		<div class="flex flex-row">
			<div class="verification-head">
				<div class="verification-head__title">Vehicle Details</div>
			</div>
		</div>
	</ng-template>
	<div>
		<p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>
		<ng-container *ngIf="activeMenuTab === menuTab.Vehicle && vehicle">
			<div class="taxi-vehicle-info">
				<div class="row">
					<div class="taxi-vehicle-label">Vehicle ID</div>
					<div class="taxi-vehicle-value">{{vehicle.Id}}</div>
				</div>
				<div class="row">
					<div class="taxi-vehicle-label">Make</div>
					<div class="taxi-vehicle-value">{{vehicle.Brand}}</div>
				</div>
				<div class="row">
					<div class="taxi-vehicle-label">Car Model</div>
					<div class="taxi-vehicle-value">{{vehicle.Model}}</div>
				</div>
				<div class="row">
					<div class="taxi-vehicle-label">Year</div>
					<div class="taxi-vehicle-value">{{vehicle.Year}}</div>
				</div>
				<div class="row">
					<div class="taxi-vehicle-label">Chassis Number</div>
					<div class="taxi-vehicle-value">{{vehicle.ChassisNumber}}</div>
				</div>
				<div class="row">
					<div class="taxi-vehicle-label">Number Plate</div>
					<div class="taxi-vehicle-value">{{vehicle.NumberPlate}}</div>
				</div>
				<div class="row">
					<div class="taxi-vehicle-label">LTFRB Case Number</div>
					<div class="taxi-vehicle-value">{{vehicle.LTFRBCaseNumber}}</div>
				</div>
				<div class="row">
					<div class="taxi-vehicle-label">Vehicle Color</div>
					<div class="taxi-vehicle-value">{{vehicle.Color}}</div>
				</div>
			</div>

		</ng-container>
		<ng-container *ngIf="activeMenuTab === menuTab.Driver">
			<div class="driver-section">
				<div class="driver-header">
					<h3 class="driver-title">Assigned Driver/s</h3>
					<button *ngIf="vehiclePool === 'connex'" icon="pi pi-plus" class="bluedark-btn" pButton label="Add Driver" (click)="addDriver()"></button>
				</div>
				
				<div class="drivers-list" *ngIf="drivers.length > 0">
					<div class="" *ngFor="let driver of drivers; let i = index">
						<div class="driver-item-header">
							<h4 class="driver-number">Driver {{i + 1}}</h4>
							<button *ngIf="vehiclePool === 'connex'" class="btn btn-danger remove-driver-btn" (click)="removeDriver(driver.id)">
								Remove Driver
							</button>
						</div>
						<div class="driver-details driver-item">
							<div class="driver-field-row">
								<div class="field-label flex-1 flex-col">First Name</div>
								<div class="field-value flex-1 flex-col">{{driver.firstName}}</div>
							</div>
							<div class="driver-field-row">
								<div class="field-label flex-1 flex-col">Last Name</div>
								<div class="field-value flex-1 flex-col">{{driver.lastName}}</div>
							</div>
							<div class="driver-field-row">
								<div class="field-label flex-1 flex-col">Phone No.</div>
								<div class="field-value flex-1 flex-col">{{driver.phoneNo}}</div>
							</div>
							<div class="driver-field-row">
								<div class="field-label flex-1 flex-col">Email</div>
								<div class="field-value flex-1 flex-col">{{driver.email}}</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="no-drivers" *ngIf="drivers.length === 0">
					<p>No drivers assigned to this vehicle.</p>
				</div>
			</div>
		</ng-container>
	</div>
</p-sidebar>
